import { Link } from "react-router-dom";

interface ComicData {
  id: number;
  slug: string;
  title: string;
  author: string;
  category: string;
  rating: number;
  status: string;
  chapters: number;
  views: string;
  description: string;
  updateTime: string;
  cover: string;
}

interface ComicCardProps {
  comic: ComicData;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.slug}`}
      className="group block rounded-lg overflow-hidden bg-background-100 hover:bg-background-200/70 transition-all duration-300"
      data-product-shop
    >
      <div className="relative aspect-[5/7] overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title} - 韩国漫画`}
          title={`${comic.title} - 高清韩漫在线免费阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${comic.status === "已完结" ? "bg-accent-100 text-accent-800" : "bg-primary-100 text-primary-700"}`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute top-2 right-2 bg-background-950/70 text-background-50 px-2 py-0.5 rounded-full text-xs font-medium flex items-center gap-1">
          <i className="ri-star-fill text-accent-500 text-[10px]"></i>
          {comic.rating}
        </div>
      </div>
      <div className="p-3">
        <h3 className="font-heading text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors truncate">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{comic.author} · {comic.chapters}话</p>
        <p className="text-xs text-foreground-400 mt-0.5">{comic.views} 阅读</p>
      </div>
    </Link>
  );
}